import styled from "styled-components";

const Container = styled.div`
  text-align: center;
  margin: 10px;
`;

const Deck = styled.div`
  padding: 16px;
  background: #0b1119;
  border-radius: 5px;
`;

const DeckPlayer = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.3rem;
  background: #ffffff0f;
  padding: 0 8px;
  border-radius: 5px;
  margin-right: 8px;
`;

const Trainers = styled.div`
  display: inline-grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  grid-gap: 16px;

  @media (min-width: 900px) {
    grid-template-columns: repeat(6, 120px);
  }
`;

const Skills = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  grid-gap: 8px;
  padding: 16px 0;
`;

const Ratings = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 20px;

  span {
    font-weight: 600;
  }
`;

const Group = styled.div`
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #172536;

  &:first-child {
    margin-top: 0;
    padding-top: 0;
    border-top: 0;
  }
`;

const GroupTitle = styled.div`
  display: flex;
  margin-bottom: 16px;
  text-align: left;
  font-weight: 600;
  font-size: 1.1rem;
  align-items: center;

  span {
    font-weight: 500;
    margin-left: auto;
  }
`;

const SpecialTraining = styled.div``;

const DeckStyles = {
  Container,
  Group,
  GroupTitle,
  Deck,
  DeckPlayer,
  Trainers,
  Skills,
  Ratings,
  SpecialTraining,
};

export default DeckStyles;
